export const GOOGLE_MAPS_API_KEY = {
    MAIN_KEY: 'AIzaSyC-ahgqsPN7HgQz_2fjWFLlUYzQkI6FHKo',
};